import { appRouterPaths } from 'services/navigation';
import { EducationPlansPage } from 'pages/EducationPlans';
import { EducationPlanOopPage } from 'pages/EducationPlanOop';
import { EducationPlanPage } from 'pages/EducationPlan';
import type { AppRouteProps } from '../types';

export const educationPlansPageRoute: AppRouteProps = {
  path: appRouterPaths.educationPlans,
  element: <EducationPlansPage />,
};

export const educationPlanPageRoute: AppRouteProps = {
  path: appRouterPaths.educationPlan,
  element: <EducationPlanPage />,
};

export const educationPlanOopPageRoute: AppRouteProps = {
  path: appRouterPaths.educationPlanOop,
  element: <EducationPlanOopPage />,
};
